export const Pin = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.93549 13.3031L18.6901 26.0471" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M19.4086 2.7063L29.3076 12.5971" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M2.67911 29.3075L12.4202 19.6089" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M16.2487 23.8024L27.2599 10.7665" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8.40018 15.6376L21.3248 4.70056" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
